module.exports = __webpack_public_path__ + "static/media/LargeBottleCircle.031924cd.png";